// src/features/excursions/components/ExcursionTable.jsx
import React from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/table";
import { Button } from "components/ui/button";
import { ArrowUpDown } from "lucide-react";
import ExcursionRow from "./ExcursionRow";
import ExcursionCard from "./ExcursionCard";

function ExcursionTable({
  excursions,
  onMarkPresent,
  onUpdateLunchInfo,
  onUpdateExcursion,
  canEdit,
  onEditExcursion,
  onDeleteExcursion,
  sortDirection,
  onSort,
}) {
  if (!excursions || excursions.length === 0) {
    return (
      <p className="text-center text-gray-400 mt-4">
        Nenhuma excursão encontrada para esta data.
      </p>
    );
  }

  return (
    <>
      {/* VISUALIZAÇÃO EM TABELA PARA DESKTOP */}
      <div className="hidden md:block rounded-md border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[40px] text-center">#</TableHead>
              <TableHead>
                <Button variant="ghost" onClick={onSort}>
                  Cliente / Telefone
                  <ArrowUpDown className="ml-2 h-4 w-4" />
                </Button>
              </TableHead>
              <TableHead>Cidade/Origem</TableHead>
              <TableHead className="w-[100px] text-center">Qtd</TableHead>
              <TableHead>Pagamento</TableHead>
              <TableHead>Camarote</TableHead>
              <TableHead>Obs.</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {excursions.map((excursion, index) => (
              <ExcursionRow
                key={excursion.id}
                excursion={excursion}
                index={index}
                onMarkPresent={onMarkPresent}
                onUpdateLunchInfo={onUpdateLunchInfo}
                onUpdateExcursion={onUpdateExcursion}
                onEdit={() => onEditExcursion(excursion)}
                onDelete={() => onDeleteExcursion(excursion.id)}
                canEdit={canEdit}
              />
            ))}
          </TableBody>
        </Table>
      </div>

      {/* VISUALIZAÇÃO EM CARDS PARA CELULAR */}
      <div className="md:hidden space-y-4">
        {excursions.map((excursion, index) => (
          <ExcursionCard
            key={excursion.id}
            excursion={excursion}
            index={index}
            onMarkPresent={onMarkPresent}
            onUpdateLunchInfo={onUpdateLunchInfo}
            onUpdateExcursion={onUpdateExcursion}
            onEdit={() => onEditExcursion(excursion)}
            onDelete={() => onDeleteExcursion(excursion.id)}
            canEdit={canEdit}
          />
        ))}
      </div>
    </>
  );
}

export default ExcursionTable;
